import React, { useState } from 'react';
import { Row, Col, Button, Modal, Form, InputGroup, Dropdown } from 'react-bootstrap';
// utils
import { handlerErrors } from 'utils/handleErrors';
import { toUpperIfString } from 'utils/textFormat';
import CsLineIcons from 'cs-line-icons/CsLineIcons';
// components
import ButtonRequest from '../buttons/ButtonRequest';
import { ToastSuccess } from '../alerts/toast';
// API
import { editBillingData } from '../../api/Api-user';
import { useHandleResponse } from '../../hooks/useHandleResponse';

const EditBillingUserModal = ({ isModalOpen, setIsModalOpen, data, setUpdatePage }) => {
  // console.log('EditBillingUserModal ---->', data);
  const { handleResponse } = useHandleResponse();
  const [isSaveDataLoader, setIsSaveDataLoader] = useState(false);
  const initialDataToActive = {
    legalName: '',
    rfc: '',
    system: '',
    street: '',
    streetNumber: '',
    zip: '',
    neighborhood: '',
    city: '',
    state: '',
    email: '',
    wantsInvoice: true,
  };
  const initialDataToEdit = {
    legalName: toUpperIfString(data.legal_name),
    rfc: data.tax_id,
    system: data.tax_system,
    street: toUpperIfString(data.street),
    streetNumber: data.street_number,
    zip: data.zip_code,
    neighborhood: toUpperIfString(data.neighborhood),
    city: toUpperIfString(data.city),
    state: toUpperIfString(data.state),
    email: data.billing_email,
    wantsInvoice: true,
  };
  const [dataToUpdate, setDataToUpdate] = useState(data.wants_invoice ? initialDataToEdit : initialDataToActive);
  const fiscalRegimes = [
    { code: '601', name: 'General de Ley Personas Morales' },
    { code: '603', name: 'Personas Morales con Fines no Lucrativos' },
    { code: '605', name: 'Sueldos y Salarios e Ingresos Asimilados a Salarios' },
    { code: '606', name: 'Arrendamiento' },
    { code: '607', name: 'Régimen de Enajenación o Adquisición de Bienes' },
    { code: '608', name: 'Demás Ingresos' },
    { code: '610', name: 'Residentes en el Extranjero sin Establecimiento Permanente en México' },
    { code: '611', name: 'Ingresos por Dividendos (socios y accionistas)' },
    { code: '612', name: 'Personas Físicas con Actividades Empresariales y Profesionales' },
    { code: '614', name: 'Ingresos por intereses' },
    { code: '615', name: 'Régimen de los ingresos por obtención de premios' },
    { code: '616', name: 'Sin obligaciones fiscales' },
    { code: '620', name: 'Sociedades Cooperativas de Producción que optan por diferir sus ingresos' },
    { code: '621', name: 'Incorporación Fiscal' },
    { code: '622', name: 'Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras' },
    { code: '623', name: 'Opcional para Grupos de Sociedades' },
    { code: '624', name: 'Coordinados' },
    { code: '625', name: 'Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas' },
    { code: '626', name: 'Régimen Simplificado de Confianza' },
  ];
  const handlerEditUserBilling = async () => {
    try {
      setIsSaveDataLoader(true); // active loader in the button
      const response = await editBillingData(dataToUpdate);
      // console.log('response edit/save billing:', response);
      if (response.status === 206) {
        setIsModalOpen(false);
      }
      handleResponse(response, (res) => {
        if (res?.data.success !== undefined) {
          ToastSuccess(response.data.message);
          setIsModalOpen(false);
          setUpdatePage((prev) => !prev);
        }
      });
    } catch (error) {
      handlerErrors(error);
    } finally {
      setIsSaveDataLoader(false);
    }
  };

  return (
    <Modal size="lg" show={isModalOpen} onHide={() => setIsModalOpen(false)}>
      <Modal.Header closeButton>
        <Modal.Title className="text-primary">{`${data.wants_invoice ? 'Editar' : 'Activar '} facturación`}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Row className="g-3">
            <div>Tu información será validada con el SAT. Asegúrate de usar los datos tal como aparecen en tu Constancia de Situación Fiscal.</div>
            <Col lg="8" className="position-relative">
              <Form.Label>Razón Social</Form.Label>
              <span className="text-primary">*</span>
              {/* <Form.Text className="text-muted">Ingresa solo el nombre de la empresa, sin “S.A. de C.V.”</Form.Text> */}
              <InputGroup>
                <InputGroup.Text>
                  <CsLineIcons icon="user" size="16" className="text-alternate" />
                </InputGroup.Text>
                <Form.Control
                  required
                  type="text"
                  value={dataToUpdate.legalName}
                  onChange={(e) => {
                    setDataToUpdate({ ...dataToUpdate, legalName: e.target.value.toUpperCase() });
                  }}
                />
              </InputGroup>
              <Form.Text>Ingresa solo el nombre de la empresa, sin “S.A. de C.V.”</Form.Text>
            </Col>
            <Col lg="4" className="position-relative">
              <Form.Label>RFC</Form.Label>
              <span className="text-primary">*</span>
              <InputGroup>
                <InputGroup.Text>
                  <CsLineIcons icon="shield" size="16" className="text-alternate" />
                </InputGroup.Text>
                <Form.Control
                  required
                  type="text"
                  value={dataToUpdate.rfc}
                  onChange={(e) => {
                    // setAddressError({ ...addressError, name: false });
                    setDataToUpdate({ ...dataToUpdate, rfc: e.target.value });
                  }}
                />
              </InputGroup>

              {/* {addressError.company && <div className={`invalid-tooltip ${addressError.company ? 'd-block' : 'd-none'}`}>{addressError.company}</div>} */}
            </Col>
            <Col lg="8" className="position-relative">
              <Form.Label>Correo</Form.Label> <span className="text-primary">*</span>
              <InputGroup>
                <InputGroup.Text>
                  <CsLineIcons icon="email" size="16" className="text-alternate" />
                </InputGroup.Text>
                <Form.Control
                  required
                  type="email"
                  value={dataToUpdate.email}
                  onChange={(e) => {
                    setDataToUpdate({ ...dataToUpdate, email: e.target.value });
                  }}
                />
              </InputGroup>
              {/* <span className="text-medium">Las facturas se enviarán a este correo</span> */}
              <Form.Text>Las facturas se enviarán a este correo</Form.Text>
            </Col>
            <Col lg="4" className="position-relative">
              <Form.Label>Régimen Fiscal</Form.Label>
              <span className="text-primary">*</span>
              <Dropdown className="w-100">
                <Dropdown.Toggle variant="foreground-alternate" className="text-end shadow d-flex justify-content-between align-items-center w-100">
                  {dataToUpdate.system || 'Seleccionar'}
                </Dropdown.Toggle>
                <Dropdown.Menu className="shadow " style={{ maxHeight: '280px', overflowY: 'scroll' }}>
                  {fiscalRegimes.map((element, index) => (
                    <Dropdown.Item
                      key={index}
                      style={{
                        whiteSpace: 'normal',
                        wordBreak: 'break-word',
                      }}
                      className={`${dataToUpdate.system === element.code && 'text-danger'}`}
                      onClick={() =>
                        setDataToUpdate((prevValues) => {
                          return { ...prevValues, system: element.code };
                        })
                      }
                    >
                      {`${element.code} | ${element.name}`}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
              {/* <span className="text-medium">Debe coincidir con tu registro en SAT</span> */}
              <Form.Text>Debe coincidir con tu registro en SAT</Form.Text>
            </Col>
            <Col md="8" lg="8" className="position-relative">
              <Form.Label>Calle</Form.Label> <span className="text-primary">*</span>
              <InputGroup>
                <InputGroup.Text>
                  <CsLineIcons icon="destination" size="16" className="text-alternate" />
                </InputGroup.Text>
                <Form.Control
                  required
                  value={dataToUpdate.street}
                  onChange={(e) => {
                    setDataToUpdate({ ...dataToUpdate, street: e.target.value.toUpperCase() });
                  }}
                />
              </InputGroup>
            </Col>
            <Col md="4" lg="4" className="position-relative">
              <Form.Label>Número</Form.Label>
              <span className="text-primary">*</span>
              <InputGroup>
                <InputGroup.Text>
                  <CsLineIcons icon="sign" size="16" className="text-alternate" />
                </InputGroup.Text>
                <Form.Control
                  type="text"
                  value={dataToUpdate.streetNumber}
                  onChange={(e) => {
                    setDataToUpdate({ ...dataToUpdate, streetNumber: e.target.value });
                  }}
                />
              </InputGroup>
            </Col>
            <Col md="8" lg="8" className="position-relative">
              <Form.Label>Colonia</Form.Label>
              <span className="text-primary">*</span>
              <InputGroup>
                <InputGroup.Text>
                  <CsLineIcons icon="pin" size="16" className="text-alternate" />
                </InputGroup.Text>
                <Form.Control
                  type="text"
                  value={dataToUpdate.neighborhood}
                  onChange={(e) => {
                    setDataToUpdate({ ...dataToUpdate, neighborhood: e.target.value.toUpperCase() });
                  }}
                />
              </InputGroup>
            </Col>
            <Col md="4" lg="4" className="position-relative">
              <Form.Label>C.P.</Form.Label>
              <span className="text-primary">*</span>
              <InputGroup>
                <InputGroup.Text>
                  <CsLineIcons icon="pin" size="16" className="text-alternate" />
                </InputGroup.Text>
                <Form.Control
                  type="text"
                  value={dataToUpdate.zip}
                  onChange={(e) => {
                    setDataToUpdate({ ...dataToUpdate, zip: e.target.value });
                  }}
                />
              </InputGroup>
              <Form.Text>Debe coincidir con tu registro en SAT</Form.Text>
            </Col>
            <Col md="8" lg="6" className="position-relative">
              <Form.Label>Ciudad</Form.Label>
              <span className="text-primary">*</span>
              <InputGroup>
                <InputGroup.Text>
                  <CsLineIcons icon="building" size="16" className="text-alternate" />
                </InputGroup.Text>
                <Form.Control
                  type="text"
                  value={dataToUpdate.city}
                  onChange={(e) => {
                    setDataToUpdate({ ...dataToUpdate, city: e.target.value.toUpperCase() });
                  }}
                />
              </InputGroup>
            </Col>
            <Col md="8" lg="6" className="position-relative">
              <Form.Label>Estado</Form.Label>
              <span className="text-primary">*</span>
              <InputGroup>
                <InputGroup.Text>
                  <CsLineIcons icon="image" size="16" className="text-alternate" />
                </InputGroup.Text>
                <Form.Control
                  type="text"
                  value={dataToUpdate.state}
                  onChange={(e) => {
                    // setAddressError({ ...addressError, name: false });
                    setDataToUpdate({ ...dataToUpdate, state: e.target.value.toUpperCase() });
                  }}
                />
              </InputGroup>
              {/* {addressError.phone && <div className={`invalid-tooltip ${addressError.phone ? 'd-block' : 'd-none'}`}>{addressError.phone}</div>} */}
            </Col>
          </Row>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-primary" onClick={() => setIsModalOpen(false)} style={{ height: '36px' }} className="ms-2">
          Cancelar
        </Button>
        <ButtonRequest
          title="Guardar"
          titleLoading="Guardando"
          handlerFn={handlerEditUserBilling}
          isButtonDisabled={isSaveDataLoader}
          isLoading={isSaveDataLoader}
        />
      </Modal.Footer>
    </Modal>
  );
};

export default EditBillingUserModal;
